import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterOutlet} from '@angular/router';
import {PersonComponent} from "../application/person.component";

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, PersonComponent],
  template: `
    <app-person></app-person>
    <router-outlet></router-outlet>
    <div style="height:100px;"></div>
  `,
  styles: []
})
export class LayoutComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }


}
